import { Component } from '@theme/component';
import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class ShippingStatus extends Component {
  connectedCallback() {
    super.connectedCallback();
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card');
    if (!target) return;
    target.addEventListener(ThemeEvents.variantUpdate, this.updateStatus);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card');
    if (!target) return;
    target.removeEventListener(ThemeEvents.variantUpdate, this.updateStatus);
  }

  /**
   * Updates the shipping status when the selected variant changes.
   * @param {VariantUpdateEvent} event
   */
  updateStatus = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newStatus = event.detail.data.html.querySelector('shipping-status');

    if (!newStatus) return;

    morph(this, newStatus, { childrenOnly: true });
    this.dataset.status = newStatus.dataset.status;
    this.style.cssText = newStatus.style.cssText;
  };
}

if (!customElements.get('shipping-status')) {
  customElements.define('shipping-status', ShippingStatus);
}
